export const getFiltersParams = (selectedInputs) => {
	return selectedInputs.reduce((acc, item) => {
		if (item?.value) {
			acc[item.key] = item.value === 'Active' ? 1 : item.value === 'Inactive' ? 0 : item.value;
		}
		return acc;
	}, {});
};

export const headerDropdownMap = {
	out_of_stocks: 'Out Of Stocks',
	low_stock_products: 'Low Stock Products',
	excess_stocks: 'Excess Stocks',
	near_expiry_stocks: 'Near Expiry Stocks',
	expired_stocks: 'Expired Stocks',
	sales_product: 'Sales',
	purchase_product: 'Purchase',
};

export const formatFilterName = (key) =>
	key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
